<router-outlet></router-outlet>

<!-- Loader global con branding Fogón (rojo + naranja). -->
<ngx-spinner bdColor="rgba(28, 11, 8, 0.78)" size="medium" color="#7C1E16" type="ball-clip-rotate-multiple"
    [fullScreen]="true">
    <div class="fg-loader">
        <div class="fg-loader-ring">
            <span class="fg-loader-flame">🔥</span>
        </div>
        <p class="fg-loader-text">Procesando...</p>
    </div>
</ngx-spinner>